import React from "react";
import { Link } from "react-router-dom";
import { Instagram, ArrowRight } from "lucide-react";
import { founder } from "../../mock";

const Team = () => {
  return (
    <section id="team" className="bg-[#f3f1ec] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        {/* Image */}
        <div className="reveal-left relative">
          <div className="relative overflow-hidden aspect-[4/5] max-w-[520px] mx-auto lg:mx-0">
            <img src="/team/omer-hero-balcony.webp" alt={founder.name} className="w-full h-full object-cover" />
            <div className="absolute inset-0 ring-1 ring-black/5" />
          </div>
          <div className="absolute -bottom-6 -right-2 lg:right-8 bg-[#0d0d0d] text-white px-6 py-4">
            <p className="font-serif-display text-2xl leading-none">#1</p>
            <p className="text-[9px] tracking-luxe uppercase text-white/60 mt-1">Founder &amp; Managing Partner</p>
          </div>
        </div>

        {/* Bio */}
        <div className="reveal">
          <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-5">{founder.role}</p>
          <h2 className="font-serif-display text-5xl md:text-6xl lg:text-7xl font-light text-[#1a1a1a] mb-8">
            Omer <span className="italic">Reshid</span>
          </h2>
          <div className="space-y-5 text-neutral-600 text-[15px] leading-relaxed max-w-xl">
            {founder.bio.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          <div className="flex items-center gap-6 mt-10">
            <a href={founder.instagram} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[11px] tracking-luxe uppercase text-[#1a1a1a] border border-[#1a1a1a] px-6 py-3 hover:bg-[#1a1a1a] hover:text-white transition-colors">
              <Instagram size={15} /> {founder.handle}
            </a>
            <a href="#contact" className="inline-flex items-center gap-2 text-[11px] tracking-luxe uppercase text-[#1a1a1a] hover:text-[#b4936a] transition-colors border-b border-[#1a1a1a] hover:border-[#b4936a] pb-1">
              Work With Omer <ArrowRight size={14} />
            </a>
          </div>
          <div className="mt-6">
            <Link to="/team" className="inline-flex items-center gap-2 text-[11px] tracking-luxe uppercase text-[#b4936a] hover:text-[#1a1a1a] transition-colors">
              Meet the Full Team <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
